module.exports = __webpack_public_path__ + "media/images/athletes/537-e3341791fe49ef79b1dcd2163a70aac5.png";